import { isEmpty } from 'lodash';

import { TLanguage } from 'config/tenancy';
import { ICustomer } from 'shared/domain/entities';

import getMissingCustomerFields from './getMissingCustomerFields';
import needsGuardianValidation from './needsGuardianValidation';

export default function isCustomerRegistrationIncomplete(
  customer: ICustomer | null,
  tenancy: TLanguage,
  confirmedGuardianDocument: string | null = null,
) {
  const customerMeta = getMissingCustomerFields(customer, tenancy);

  if (!customerMeta) return false;

  return (
    !isEmpty(customerMeta.fields) ||
    needsGuardianValidation(customer, confirmedGuardianDocument)
  );
}
